// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tab-module__font-s-10___H2AUW {
  font-size: 10px !important;
}

.Tab-module__font-s-12___Josmv {
  font-size: 12px !important;
}

.Tab-module__font-s-13___BxV3e {
  font-size: 13px !important;
}

.Tab-module__font-s-14___SbgEV {
  font-size: 14px !important;
}

.Tab-module__font-s-15___s9zzf {
  font-size: 15px !important;
}

.Tab-module__font-s-16___ATR2L {
  font-size: 16px !important;
}

.Tab-module__font-s-18___ikKhq {
  font-size: 18px !important;
}

.Tab-module__font-s-20___wBUna {
  font-size: 20px !important;
}

.Tab-module__font-s-22___RJnet {
  font-size: 22px !important;
}

.Tab-module__font-s-28___ndFV2 {
  font-size: 28px !important;
}

.Tab-module__font-w-400___Tc8t9 {
  font-weight: 400 !important;
}

.Tab-module__font-w-500___SNr4_ {
  font-weight: 500 !important;
}

.Tab-module__font-w-600___zmptg {
  font-weight: 600 !important;
}

.Tab-module__font-w-700___NpdNn {
  font-weight: 700 !important;
}

.Tab-module__p-5___KMjuJ {
  padding: 5px !important;
}

.Tab-module__p-12___yUNws {
  padding: 12px !important;
}

.Tab-module__p-16___WQVK5 {
  padding: 16px !important;
}

.Tab-module__p-30___FkXg2 {
  padding: 30px !important;
}

.Tab-module__p-b-0___XQtrg {
  padding-bottom: 0 !important;
}

.Tab-module__p-b-5___e19_i {
  padding-bottom: 5px !important;
}

.Tab-module__p-b-10___BgD9s {
  padding-bottom: 10px !important;
}

.Tab-module__p-b-12___nWM3q {
  padding-bottom: 12px !important;
}

.Tab-module__p-b-16___TvkYu {
  padding-bottom: 16px !important;
}

.Tab-module__p-b-18___ad4cI {
  padding-bottom: 18px !important;
}

.Tab-module__p-b-20___G95Oe {
  padding-bottom: 20px !important;
}

.Tab-module__p-b-25___QOWFM {
  padding-bottom: 25px !important;
}

.Tab-module__p-b-30___LQGdh {
  padding-bottom: 30px !important;
}

.Tab-module__p-b-50___qtvn2 {
  padding-bottom: 50px !important;
}

.Tab-module__p-t-0___QqaU8 {
  padding-top: 0 !important;
}

.Tab-module__p-t-12___UZ4Y9 {
  padding-top: 12px !important;
}

.Tab-module__p-t-16___piZir {
  padding-top: 16px !important;
}

.Tab-module__p-t-18___GFgQ0 {
  padding-top: 18px !important;
}

.Tab-module__p-t-20___Q4UwP {
  padding-top: 20px !important;
}

.Tab-module__p-t-30___xbfTU {
  padding-top: 30px !important;
}

.Tab-module__p-t-40___Os06W {
  padding-top: 40px !important;
}

.Tab-module__p-t-50___WBrN7 {
  padding-top: 50px !important;
}

.Tab-module__p-l-20___KvVRl {
  padding-left: 20px !important;
}

.Tab-module__p-l-30___uCKQa {
  padding-left: 30px !important;
}

.Tab-module__p-l-40___zVjeq {
  padding-left: 40px !important;
}

.Tab-module__p-r-16___IACoe {
  padding-right: 16px !important;
}

.Tab-module__p-r-20___kxvw3 {
  padding-right: 20px !important;
}

.Tab-module__p-r-30___Kwwl4 {
  padding-right: 30px !important;
}

.Tab-module__p-r-50___Wm5jL {
  padding-right: 50px !important;
}

.Tab-module__p-r-60___vXI7x {
  padding-right: 60px !important;
}

.Tab-module__m-b-1___SSyge {
  margin-bottom: 1px !important;
}

.Tab-module__m-b-2___ww_Bv {
  margin-bottom: 2px !important;
}

.Tab-module__m-b-6___PE1tw {
  margin-bottom: 6px !important;
}

.Tab-module__m-b-8___nYutA {
  margin-bottom: 8px !important;
}

.Tab-module__m-b-10___GgTng {
  margin-bottom: 10px !important;
}

.Tab-module__m-b-14___BKaeX {
  margin-bottom: 14px !important;
}

.Tab-module__m-b-16___JOaJb {
  margin-bottom: 16px !important;
}

.Tab-module__m-b-20___qoAjq {
  margin-bottom: 20px !important;
}

.Tab-module__m-b-22___cjiKD {
  margin-bottom: 22px !important;
}

.Tab-module__m-b-24___QkZqS {
  margin-bottom: 24px !important;
}

.Tab-module__m-b-30___iNYKV {
  margin-bottom: 30px !important;
}

.Tab-module__m-b-32___ssxGp {
  margin-bottom: 32px !important;
}

.Tab-module__m-b-40___jQyaE {
  margin-bottom: 40px !important;
}

.Tab-module__m-t-2___Oa1RK {
  margin-top: 2px !important;
}

.Tab-module__m-t-3___aDIk0 {
  margin-top: 3px !important;
}

.Tab-module__m-t-4___x8aN4 {
  margin-top: 4px !important;
}

.Tab-module__m-t-5___qFLMQ {
  margin-top: 5px !important;
}

.Tab-module__m-t-8___J97Sc {
  margin-top: 8px !important;
}

.Tab-module__m-t-10___TJ64A {
  margin-top: 10px !important;
}

.Tab-module__m-t-15___Ky23r {
  margin-top: 15px !important;
}

.Tab-module__m-t-16___yf1hj {
  margin-top: 16px !important;
}

.Tab-module__m-t-20___Ax_iG {
  margin-top: 20px !important;
}

.Tab-module__m-t-22___KseoQ {
  margin-top: 22px !important;
}

.Tab-module__m-t-30___W0Tui {
  margin-top: 30px !important;
}

.Tab-module__m-t-32___DZWst {
  margin-top: 32px !important;
}

.Tab-module__m-l-auto___bvffZ {
  margin-left: auto !important;
}

.Tab-module__m-l-4___vNyDC {
  margin-left: 4px !important;
}

.Tab-module__m-l-5___wzSMv {
  margin-left: 5px !important;
}

.Tab-module__m-l-6___ZYKNB {
  margin-left: 6px !important;
}

.Tab-module__m-l-8___nZxBQ {
  margin-left: 8px !important;
}

.Tab-module__m-l-10___o5mJm {
  margin-left: 10px !important;
}

.Tab-module__m-l-16___CwYyi {
  margin-left: 16px !important;
}

.Tab-module__m-l-20___jf88Y {
  margin-left: 20px !important;
}

.Tab-module__m-l-24___CFc3u {
  margin-left: 24px !important;
}

.Tab-module__m-l-30___MbTN3 {
  margin-left: 30px !important;
}

.Tab-module__m-l-35___yEceS {
  margin-left: 35px !important;
}

.Tab-module__m-l-40___LvDzg {
  margin-left: 40px !important;
}

.Tab-module__m-r-8___ORUdz {
  margin-right: 8px !important;
}

.Tab-module__m-r-10___sTZ2L {
  margin-right: 10px !important;
}

.Tab-module__m-r-16___X0XyA {
  margin-right: 16px !important;
}

.Tab-module__m-r-20___t_Z9y {
  margin-right: 20px !important;
}

.Tab-module__m-r-24___ORGL9 {
  margin-right: 24px !important;
}

.Tab-module__m-r-30___KIyCb {
  margin-right: 30px !important;
}

.Tab-module__m-r-40___uNjob {
  margin-right: 40px !important;
}

.Tab-module__border-r-3___mR7mL {
  border-radius: 3px !important;
}

.Tab-module__border-r-4___a8Ugk {
  border-radius: 4px !important;
}

.Tab-module__border-r-6___PSx2B {
  border-radius: 6px !important;
}

.Tab-module__border-r-10___FFAd3 {
  border-radius: 10px !important;
}

.Tab-module__border-r-12___rIJ20 {
  border-radius: 12px !important;
}

.Tab-module__border-r-16___Cv8dj {
  border-radius: 16px !important;
}

.Tab-module__border-r-50___D7TPP {
  border-radius: 50% !important;
}

.Tab-module__primary-border___siCxb {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Tab-module__primary-border-b___PVpVM {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Tab-module__primary-border-t___qb60v {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Tab-module__primary-border-l___ZyItZ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Tab-module__primary-border-r___wEmOP {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Tab-module__secondary-border___XryNT {
  border: 1px solid #637768;
}

.Tab-module__secondary-border-b___MjP5b {
  border-bottom: 1px solid #637768;
}

.Tab-module__secondary-border-t___soNwO {
  border-top: 1px solid #637768;
}

.Tab-module__secondary-border-l___i4Yid {
  border-left: 1px solid #637768;
}

.Tab-module__secondary-border-r___mqt0q {
  border-right: 1px solid #637768;
}

.Tab-module__gap-0___YLSER {
  gap: 0 !important;
}

.Tab-module__gap-2___lPDW0 {
  gap: 2px !important;
}

.Tab-module__gap-4___GCNNd {
  gap: 4px !important;
}

.Tab-module__gap-5___imom2 {
  gap: 5px !important;
}

.Tab-module__gap-6___zduwn {
  gap: 6px !important;
}

.Tab-module__gap-8___W8tlT {
  gap: 8px !important;
}

.Tab-module__gap-10___CRKI2 {
  gap: 10px !important;
}

.Tab-module__gap-12___D_one {
  gap: 12px !important;
}

.Tab-module__gap-14___SScY2 {
  gap: 14px !important;
}

.Tab-module__gap-16___BtUR4 {
  gap: 16px !important;
}

.Tab-module__gap-18___P7_5V {
  gap: 18px !important;
}

.Tab-module__gap-20___ftieq {
  gap: 20px !important;
}

.Tab-module__gap-24___zq0aJ {
  gap: 24px !important;
}

.Tab-module__gap-26___HxT97 {
  gap: 26px !important;
}

.Tab-module__gap-30___G5k8J {
  gap: 30px !important;
}

.Tab-module__gap-32___ZmzSx {
  gap: 32px !important;
}

.Tab-module__gap-40___qzgLC {
  gap: 40px !important;
}

.Tab-module__gap-50___HK01u {
  gap: 50px !important;
}

.Tab-module__flex-1___P2vxO {
  flex: 1;
}

.Tab-module__flex-none___fEjmM {
  flex: none !important;
}

.Tab-module__flex-column___p7Qic {
  display: flex;
  flex-direction: column !important;
}

.Tab-module__flex-row___Vo_vL {
  display: flex;
  flex-direction: row !important;
}

.Tab-module__vertically-centered___DAd4f {
  display: flex;
  align-items: center !important;
}

.Tab-module__horizontally-centered____aDnT {
  display: flex;
  justify-content: center !important;
}

.Tab-module__horizontally-end___DMfYC {
  display: flex;
  justify-content: end !important;
}

.Tab-module__vertically-start___aRKcY {
  display: flex;
  align-items: start !important;
}

.Tab-module__space-between___ukjf6 {
  display: flex;
  justify-content: space-between !important;
}

.Tab-module__flex-wrap___bQTH8 {
  flex-wrap: wrap !important;
}

.Tab-module__height-100___VCuRp {
  height: 100%;
}

.Tab-module__width-50___x1S7S {
  width: 50% !important;
}

.Tab-module__width-100___U7V7E {
  width: 100%;
}

.Tab-module__cursor-pointer___m4k7J {
  cursor: pointer;
}

.Tab-module__cursor-not-allowed___DJQT0 {
  cursor: not-allowed !important;
}

.Tab-module__absolute-centered___iG9c_ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Tab-module__absolute___rBDII {
  position: absolute;
}

.Tab-module__relative___OAQkV {
  position: relative;
}

.Tab-module__fixed___vJ8p0 {
  position: fixed;
}

.Tab-module__visible___o5cjO {
  opacity: 1;
}

.Tab-module__invisible___kFV0n {
  opacity: 0;
}

.Tab-module__col-90___WWtXe {
  width: 90% !important;
}

.Tab-module__col-auto___txv_B {
  width: auto !important;
}

.Tab-module__medical-tabs___tEQMU {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Tab-module__medical-table-new___CwnwE {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Tab-module__medical-table-new___CwnwE:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Tab-module__medical-table-new___CwnwE::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Tab-module__medical-table-new___CwnwE::-webkit-scrollbar-track {
  display: none;
}
.Tab-module__medical-table-new___CwnwE.Tab-module__no-pagination___MaL7S {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Tab-module__medical-table-new___CwnwE.Tab-module__no-pagination___MaL7S:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Tab-module__medical-table-new___CwnwE.Tab-module__no-pagination___MaL7S::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Tab-module__medical-table-new___CwnwE.Tab-module__no-pagination___MaL7S::-webkit-scrollbar-track {
  display: none;
}

.Tab-module__medical-table-empty___Sc_Sl {
  padding: 14px 40px !important;
}

.Tab-module__icon-btn___cK18O {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Tab-module__search-icon___Dp3Sl {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Tab-module__disable-select___wX0hX {
  user-select: none;
}

.Tab-module__break-word___UwprB {
  word-break: break-word;
}

.Tab-module__popup-clear-btn___gtgaI {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Tab-module__scroll-m-b-20___VHaWV {
  scroll-margin-bottom: 20px;
}

.Tab-module__tabItem___chyDg {
  justify-content: space-between;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  cursor: pointer;
  position: relative;
}
.Tab-module__tabItem___chyDg .Tab-module__text___Sx6kT {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--font-family);
  font-weight: 400;
  color: #637768;
  line-height: 20px;
}
.Tab-module__tabItem___chyDg .Tab-module__text___Sx6kT.Tab-module__selectedText___uQXYa {
  color: #375844;
}
.Tab-module__tabItem___chyDg .Tab-module__closeIcon___UzSXm {
  width: 17px;
  height: 17px;
  margin-left: 6px;
}
.Tab-module__tabItem___chyDg .Tab-module__line___LEhux {
  position: absolute;
  display: flex;
  width: calc(100% - 25px);
  height: 4px;
  background-color: #f1bf72;
  border-radius: 6px 6px 0 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MainNavigation/components/Tabs/Tab/Tab.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,8BAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AA8pBF;AA5pBE;ECNA,gBAAA;EACA,mBAAA;EACA,uBAAA;ECoBA,+BApBO;EAqBP,gBAFmD;EFZjD,cAAA;EACA,iBAAA;AAiqBJ;AA/pBI;EACE,cAAA;AAiqBN;AA7pBE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AA+pBJ;AA5pBE;EACE,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;EACA,0BAAA;EACA,SAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.tabItem {\n  justify-content: space-between;\n  background-color: transparent;\n  height: 100%;\n  padding: 0 15px;\n  cursor: pointer;\n  position: relative;\n\n  .text {\n    @include clipped-text;\n    @include get-font($roboto);\n    color: get-color(greenNew, medium-dark);\n    line-height: 20px;\n\n    &.selectedText {\n      color: get-color(greenNew, dark);\n    }\n  }\n\n  .closeIcon {\n    width: 17px;\n    height: 17px;\n    margin-left: 6px;\n  }\n\n  .line {\n    position: absolute;\n    display: flex;\n    width: calc(100% - 25px);\n    height: 4px;\n    background-color: get-color(orangeNew);\n    border-radius: 6px 6px 0 0;\n    bottom: 0;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Tab-module__font-s-10___H2AUW`,
	"fontS12": `Tab-module__font-s-12___Josmv`,
	"fontS13": `Tab-module__font-s-13___BxV3e`,
	"fontS14": `Tab-module__font-s-14___SbgEV`,
	"fontS15": `Tab-module__font-s-15___s9zzf`,
	"fontS16": `Tab-module__font-s-16___ATR2L`,
	"fontS18": `Tab-module__font-s-18___ikKhq`,
	"fontS20": `Tab-module__font-s-20___wBUna`,
	"fontS22": `Tab-module__font-s-22___RJnet`,
	"fontS28": `Tab-module__font-s-28___ndFV2`,
	"fontW400": `Tab-module__font-w-400___Tc8t9`,
	"fontW500": `Tab-module__font-w-500___SNr4_`,
	"fontW600": `Tab-module__font-w-600___zmptg`,
	"fontW700": `Tab-module__font-w-700___NpdNn`,
	"p5": `Tab-module__p-5___KMjuJ`,
	"p12": `Tab-module__p-12___yUNws`,
	"p16": `Tab-module__p-16___WQVK5`,
	"p30": `Tab-module__p-30___FkXg2`,
	"pB0": `Tab-module__p-b-0___XQtrg`,
	"pB5": `Tab-module__p-b-5___e19_i`,
	"pB10": `Tab-module__p-b-10___BgD9s`,
	"pB12": `Tab-module__p-b-12___nWM3q`,
	"pB16": `Tab-module__p-b-16___TvkYu`,
	"pB18": `Tab-module__p-b-18___ad4cI`,
	"pB20": `Tab-module__p-b-20___G95Oe`,
	"pB25": `Tab-module__p-b-25___QOWFM`,
	"pB30": `Tab-module__p-b-30___LQGdh`,
	"pB50": `Tab-module__p-b-50___qtvn2`,
	"pT0": `Tab-module__p-t-0___QqaU8`,
	"pT12": `Tab-module__p-t-12___UZ4Y9`,
	"pT16": `Tab-module__p-t-16___piZir`,
	"pT18": `Tab-module__p-t-18___GFgQ0`,
	"pT20": `Tab-module__p-t-20___Q4UwP`,
	"pT30": `Tab-module__p-t-30___xbfTU`,
	"pT40": `Tab-module__p-t-40___Os06W`,
	"pT50": `Tab-module__p-t-50___WBrN7`,
	"pL20": `Tab-module__p-l-20___KvVRl`,
	"pL30": `Tab-module__p-l-30___uCKQa`,
	"pL40": `Tab-module__p-l-40___zVjeq`,
	"pR16": `Tab-module__p-r-16___IACoe`,
	"pR20": `Tab-module__p-r-20___kxvw3`,
	"pR30": `Tab-module__p-r-30___Kwwl4`,
	"pR50": `Tab-module__p-r-50___Wm5jL`,
	"pR60": `Tab-module__p-r-60___vXI7x`,
	"mB1": `Tab-module__m-b-1___SSyge`,
	"mB2": `Tab-module__m-b-2___ww_Bv`,
	"mB6": `Tab-module__m-b-6___PE1tw`,
	"mB8": `Tab-module__m-b-8___nYutA`,
	"mB10": `Tab-module__m-b-10___GgTng`,
	"mB14": `Tab-module__m-b-14___BKaeX`,
	"mB16": `Tab-module__m-b-16___JOaJb`,
	"mB20": `Tab-module__m-b-20___qoAjq`,
	"mB22": `Tab-module__m-b-22___cjiKD`,
	"mB24": `Tab-module__m-b-24___QkZqS`,
	"mB30": `Tab-module__m-b-30___iNYKV`,
	"mB32": `Tab-module__m-b-32___ssxGp`,
	"mB40": `Tab-module__m-b-40___jQyaE`,
	"mT2": `Tab-module__m-t-2___Oa1RK`,
	"mT3": `Tab-module__m-t-3___aDIk0`,
	"mT4": `Tab-module__m-t-4___x8aN4`,
	"mT5": `Tab-module__m-t-5___qFLMQ`,
	"mT8": `Tab-module__m-t-8___J97Sc`,
	"mT10": `Tab-module__m-t-10___TJ64A`,
	"mT15": `Tab-module__m-t-15___Ky23r`,
	"mT16": `Tab-module__m-t-16___yf1hj`,
	"mT20": `Tab-module__m-t-20___Ax_iG`,
	"mT22": `Tab-module__m-t-22___KseoQ`,
	"mT30": `Tab-module__m-t-30___W0Tui`,
	"mT32": `Tab-module__m-t-32___DZWst`,
	"mLAuto": `Tab-module__m-l-auto___bvffZ`,
	"mL4": `Tab-module__m-l-4___vNyDC`,
	"mL5": `Tab-module__m-l-5___wzSMv`,
	"mL6": `Tab-module__m-l-6___ZYKNB`,
	"mL8": `Tab-module__m-l-8___nZxBQ`,
	"mL10": `Tab-module__m-l-10___o5mJm`,
	"mL16": `Tab-module__m-l-16___CwYyi`,
	"mL20": `Tab-module__m-l-20___jf88Y`,
	"mL24": `Tab-module__m-l-24___CFc3u`,
	"mL30": `Tab-module__m-l-30___MbTN3`,
	"mL35": `Tab-module__m-l-35___yEceS`,
	"mL40": `Tab-module__m-l-40___LvDzg`,
	"mR8": `Tab-module__m-r-8___ORUdz`,
	"mR10": `Tab-module__m-r-10___sTZ2L`,
	"mR16": `Tab-module__m-r-16___X0XyA`,
	"mR20": `Tab-module__m-r-20___t_Z9y`,
	"mR24": `Tab-module__m-r-24___ORGL9`,
	"mR30": `Tab-module__m-r-30___KIyCb`,
	"mR40": `Tab-module__m-r-40___uNjob`,
	"borderR3": `Tab-module__border-r-3___mR7mL`,
	"borderR4": `Tab-module__border-r-4___a8Ugk`,
	"borderR6": `Tab-module__border-r-6___PSx2B`,
	"borderR10": `Tab-module__border-r-10___FFAd3`,
	"borderR12": `Tab-module__border-r-12___rIJ20`,
	"borderR16": `Tab-module__border-r-16___Cv8dj`,
	"borderR50": `Tab-module__border-r-50___D7TPP`,
	"primaryBorder": `Tab-module__primary-border___siCxb`,
	"primaryBorderB": `Tab-module__primary-border-b___PVpVM`,
	"primaryBorderT": `Tab-module__primary-border-t___qb60v`,
	"primaryBorderL": `Tab-module__primary-border-l___ZyItZ`,
	"primaryBorderR": `Tab-module__primary-border-r___wEmOP`,
	"secondaryBorder": `Tab-module__secondary-border___XryNT`,
	"secondaryBorderB": `Tab-module__secondary-border-b___MjP5b`,
	"secondaryBorderT": `Tab-module__secondary-border-t___soNwO`,
	"secondaryBorderL": `Tab-module__secondary-border-l___i4Yid`,
	"secondaryBorderR": `Tab-module__secondary-border-r___mqt0q`,
	"gap0": `Tab-module__gap-0___YLSER`,
	"gap2": `Tab-module__gap-2___lPDW0`,
	"gap4": `Tab-module__gap-4___GCNNd`,
	"gap5": `Tab-module__gap-5___imom2`,
	"gap6": `Tab-module__gap-6___zduwn`,
	"gap8": `Tab-module__gap-8___W8tlT`,
	"gap10": `Tab-module__gap-10___CRKI2`,
	"gap12": `Tab-module__gap-12___D_one`,
	"gap14": `Tab-module__gap-14___SScY2`,
	"gap16": `Tab-module__gap-16___BtUR4`,
	"gap18": `Tab-module__gap-18___P7_5V`,
	"gap20": `Tab-module__gap-20___ftieq`,
	"gap24": `Tab-module__gap-24___zq0aJ`,
	"gap26": `Tab-module__gap-26___HxT97`,
	"gap30": `Tab-module__gap-30___G5k8J`,
	"gap32": `Tab-module__gap-32___ZmzSx`,
	"gap40": `Tab-module__gap-40___qzgLC`,
	"gap50": `Tab-module__gap-50___HK01u`,
	"flex1": `Tab-module__flex-1___P2vxO`,
	"flexNone": `Tab-module__flex-none___fEjmM`,
	"flexColumn": `Tab-module__flex-column___p7Qic`,
	"flexRow": `Tab-module__flex-row___Vo_vL`,
	"verticallyCentered": `Tab-module__vertically-centered___DAd4f`,
	"horizontallyCentered": `Tab-module__horizontally-centered____aDnT`,
	"horizontallyEnd": `Tab-module__horizontally-end___DMfYC`,
	"verticallyStart": `Tab-module__vertically-start___aRKcY`,
	"spaceBetween": `Tab-module__space-between___ukjf6`,
	"flexWrap": `Tab-module__flex-wrap___bQTH8`,
	"height100": `Tab-module__height-100___VCuRp`,
	"width50": `Tab-module__width-50___x1S7S`,
	"width100": `Tab-module__width-100___U7V7E`,
	"cursorPointer": `Tab-module__cursor-pointer___m4k7J`,
	"cursorNotAllowed": `Tab-module__cursor-not-allowed___DJQT0`,
	"absoluteCentered": `Tab-module__absolute-centered___iG9c_`,
	"absolute": `Tab-module__absolute___rBDII`,
	"relative": `Tab-module__relative___OAQkV`,
	"fixed": `Tab-module__fixed___vJ8p0`,
	"visible": `Tab-module__visible___o5cjO`,
	"invisible": `Tab-module__invisible___kFV0n`,
	"col90": `Tab-module__col-90___WWtXe`,
	"colAuto": `Tab-module__col-auto___txv_B`,
	"medicalTabs": `Tab-module__medical-tabs___tEQMU`,
	"medicalTableNew": `Tab-module__medical-table-new___CwnwE`,
	"noPagination": `Tab-module__no-pagination___MaL7S`,
	"medicalTableEmpty": `Tab-module__medical-table-empty___Sc_Sl`,
	"iconBtn": `Tab-module__icon-btn___cK18O`,
	"searchIcon": `Tab-module__search-icon___Dp3Sl`,
	"disableSelect": `Tab-module__disable-select___wX0hX`,
	"breakWord": `Tab-module__break-word___UwprB`,
	"popupClearBtn": `Tab-module__popup-clear-btn___gtgaI`,
	"scrollMB20": `Tab-module__scroll-m-b-20___VHaWV`,
	"tabItem": `Tab-module__tabItem___chyDg`,
	"text": `Tab-module__text___Sx6kT`,
	"selectedText": `Tab-module__selectedText___uQXYa`,
	"closeIcon": `Tab-module__closeIcon___UzSXm`,
	"line": `Tab-module__line___LEhux`
};
module.exports = ___CSS_LOADER_EXPORT___;
